import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormInput from '../input/FormInput';
import { CustomGoogleMap } from '../../../../custom-widgets';
import { getGoogleMapsURL } from '../../../../../utils';

const GoogleMap = ({ defaultValue, reference, props }) => {
    const { disabled } = props || {};
    const { selectedValues, getValues, setValue, watch } = useFormContext();
    const [coordinates, setCoordinates] = useState();
    const [initialUpdated, setInitialUpdated] = useState(false);

    const updateCoordinates = ({ lat, lng }) => {
        setCoordinates({ latitude: lat, longitude: lng });
        setValue('latitude', lat.toString());
        setValue('longitude', lng.toString());
    };

    // onEdit latitude and longitude incoming values
    const [latitude, longitude] = getValues(['latitude', 'longitude']);
    // latitude and longitude from reference
    const { latitude: refLatitude, longitude: refLongitude } = selectedValues[reference] || {};
    // latitude and longitude from defaultValue in config object
    const { latitude: defaultLatitude, longitude: defaultLongitude } = defaultValue || {};

    // Order of precedence for setting initial coordinates;
    // 1. latitude and longitude from incoming values
    // 2. latitude and longitude from reference
    // 3. latitude and longitude from defaultValue in config object
    const setInitialCoordinates = () => {
        if (latitude || longitude) {
            updateCoordinates({ lat: latitude, lng: longitude });
        } else if (refLatitude || refLongitude) {
            updateCoordinates({ lat: refLatitude, lng: refLongitude });
        } else if (defaultLatitude || defaultLongitude) {
            updateCoordinates({ lat: defaultLatitude, lng: defaultLongitude });
        }
        setInitialUpdated(true);
    };

    useEffect(
        () => {
            if (!initialUpdated) {
                setInitialCoordinates();
            } else {
                const hasRefCoordinates = refLatitude || refLongitude;
                if (!disabled && hasRefCoordinates) {
                    updateCoordinates({ lat: refLatitude, lng: refLongitude });
                }
            }
        },
        !!reference ? [watch(reference)] : []
    );

    return (
        <>
            <CustomGoogleMap
                isMarkerShown
                googleMapURL={getGoogleMapsURL()}
                loadingElement={<div style={{ height: '100%' }} />}
                containerElement={<div style={{ height: '400px' }} />}
                mapElement={<div style={{ height: '100%' }} />}
                lat={coordinates?.latitude}
                lng={coordinates?.longitude}
                overrideZoom={12}
                hideSearch
                // wrap
            />
            <FormInput name="latitude" props={{ type: 'hidden' }} />
            <FormInput name="longitude" props={{ type: 'hidden' }} />
        </>
    );
};

export default GoogleMap;
